import * as Type from './types'

export function populate(data, callback = {success: null, error: null}) {
    return {
        type: Type.POPULATE,
        data: data,
        callback: callback
    }
}

export function setLoaded(value = true, callback = null) {
    return {
        type: Type.SET_LOADED,
        data: value,
        callback: callback
    }
}